<template>
  <section class="phases">
    <div class="f">
      <p class="skin-title">{{ $t('Phase') }}</p>
      <svg
          v-tooltip="$t('phases_info')"
          class="gray"
          height="20"
          width="20"
      >
        <use xlink:href="/icons/sprite.svg#i-info"></use>
      </svg>
    </div>

    <div class="phases__grid">
      <nuxt-link
          v-for="phase in phases"
          :aria-label="phase.market_hash_name"
          :class="{active: !route.params.exterior &&
              getItemLink({name: phase.market_hash_name, slug: phase.link_name}).split('/')[2] === route.params.name as string
          }"
          :to="getItemLink({name: phase.market_hash_name, slug: phase.link_name})"
          class="phases__grid-item"
          exact-active-class="active"
      >
        <div class="img-wrapper">
          <img
              :class="getModifiedString(phase.market_hash_name)"
              :src="getImageFromWaxpeer(phase.market_hash_name, '500:500')"
              :style="{
                '--img-scale': getKnifeFocusConfig(phase.market_hash_name).scale,
                '--img-translate-x': `${getKnifeFocusConfig(phase.market_hash_name).translateX}%`,
                '--img-translate-y': `${getKnifeFocusConfig(phase.market_hash_name).translateY}%`
              }"
              alt=""
          >
        </div>
        <p class="tac">{{ $t('phases.' + phase.phase) }}</p>
      </nuxt-link>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {PhaseItem} from "~/graphql/generated/schema-types";
import {getImageFromWaxpeer} from "#imports";
import phasesConfig from "~/data/phases-positions";

const props = defineProps<{
  phases: PhaseItem[],
  activeItemName: string
}>()

const route = useRoute()

const getKnifeFocusConfig = (name: string) => {
  name = name.toLowerCase()
  const key = Object.keys(phasesConfig).find(i => name.includes(i)) || 'default'
  return phasesConfig[key]
}
</script>

<style lang="scss" scoped>


.phases {
  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    @media screen and (max-width: 435px) {
      grid-template-columns: repeat(3, 1fr);
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      color: var(--surfaces-on-surface-variable);
      font-weight: 600;
      font-size: 14px;

      .img-wrapper {
        width: 60px;
        height: 60px;
        padding: 8px;
        border-radius: 50%;
        //border: 1px solid var(--surfaces-outline);
        overflow: hidden;
        position: relative;

        &:before, &:after {
          content: '';
          display: block;
          position: absolute;
          border-radius: 50%;
        }

        &:after {
          inset: -2px;
          border: 10px solid var(--accent-on-primary);
        }

        &:before {
          inset: 0;
          border: 1px solid var(--surfaces-outline);
          z-index: 1;
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          transform: scale(var(--img-scale, 1)) translate(var(--img-translate-x, 0%), var(--img-translate-y, 0%));
          transition: transform 0.3s ease;
        }
      }

      &.active {
        color: var(--accent-secondary);

        .img-wrapper:before {
          border-color: var(--accent-secondary);
        }
      }

      &:hover {
        .img-wrapper {
          img {
            transform: scale(1.2);
          }

          &:before, &:after {
            display: none;
          }
        }
      }

      @media screen and (max-width: 1115px) {
        .img-wrapper {
          img {
            transform: scale(1.2);
          }

          &:before, &:after {
            display: none;
          }
        }
      }
    }
  }
}
</style>
